<template>
    <v-container fluid class="px-0 mx-0 py-0 my-0" style="position: sticky; top: 0; z-index: 10;">
        <v-row justify="center" class="custom-header mx-0 px-0">
            <v-col cols="8" sm="9" align="start">
                <v-row no-gutters align="center" justify="center">
                    <v-col cols="12" class="py-0 my-0">
                        <v-icon class="custom-teal-text" large @click="$router.go(-1)">mdi-chevron-left</v-icon>
                        <span class="custom-teal-text">{{ title }}</span>
                    </v-col>
                    <v-col cols="12" align="start">
                        <v-icon class="custom-teal-text" @click="openSocial('facebook')"> mdi-facebook</v-icon>
                        <v-icon class="custom-teal-text mx-5" @click="openSocial('instagram')"> mdi-instagram</v-icon>
                        <v-icon class="custom-teal-text mr-5" @click="openSocial('youtube')"> mdi-youtube </v-icon>
                        <v-icon class="custom-teal-text mr-5" @click="openSocial('twitter')"> mdi-twitter </v-icon>
                        <v-icon class="custom-teal-text mr-5" @click="openSocial('linkedin')"> mdi-linkedin </v-icon>
                        <!-- <v-img
                            :width="!$vuetify.breakpoint.mobile ? '20px' : '20px'"
                            contain
                            style="display: inline-flex; bottom: 15px; position: absolute;"
                            :src="require('@/assets/tiktok-gradient.svg')"
                            @click="openSocial('tiktok')"
                        /> -->
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="4" sm="3" align="start" class="mx-0 px-0 py-0 my-0">
                <v-row class="mx-0 px-0 py-0 my-0">
                    <v-col cols="5" align="end" class="mx-0 px-0">
                        <v-btn
                            icon
                            large
                            color="teal"
                            @click="$store.getters.getTeam ? $router.push({name: 'Team', params: { id: $store.getters.getTeam.id } }) : $router.push({name: 'Profile'})"
                        >
                            <v-avatar v-if="$store.getters.getTeam" style="border-radius: 10px;" size="50px" class="mr-3" :style="`background-color: white; border-radius: 50%;`">
                                <img :src="`${assetsUrl}/${$store.getters.getTeam.logo}`" height="50px" width="auto">
                            </v-avatar>
                            <v-icon v-else class="teal--text" large>mdi-account-group</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="2" align="center" class="pb-8 mx-0 px-0">
                        <v-divider
                            vertical
                            color="teal"
                            class="custom-divider"
                        />
                    </v-col>
                    <v-col cols="5" align="start" class="mx-0 px-0">
                        <v-btn
                            icon
                            large
                            color="teal"
                            @click="$store.getters.getPlayer ? $router.push({name: 'Player', params: { id: $store.getters.getPlayer.id } }) : $router.push({name: 'Profile'})"
                        >
                            <v-img v-if="$store.getters.getPlayer" width="50" contain :src="`${assetsUrl}/${$store.getters.getPlayer.image}`" class="" />
                            <v-icon v-else class="teal--text" color="teal" large>mdi-account</v-icon>
                        </v-btn>
                        <v-row class="mx-0 px-0">
                            <v-col cols="12" align="end" class="mx-0 px-0">
                                <v-btn
                                    fab
                                    x-small
                                    class="custom-teal"
                                    to="/Profile"
                                >
                                    <v-icon class="white--text">mdi-cog</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com'
            }
        },
        methods: {
            openSocial(social) {
                if (social === 'facebook') {
                    window.open('https://www.facebook.com/eka.league.gr', '_blank')
                } else if (social === 'instagram') {
                    window.open('https://www.instagram.com/eka_league.gr/', '_blank')
                } else if (social === 'youtube') {
                    window.open('https://www.youtube.com/channel/UC5hvrVJnTvrSrcf970QpqNg', '_blank')
                } else if (social === 'tiktok') {
                    window.open('', '_blank')
                } else if (social === 'twitter') {
                    window.open('https://x.com/Comm_league', '_blank')
                } else if (social === 'linkedin') {
                    window.open('https://www.linkedin.com/company/eka-league/', '_blank')
                } else if (social === 'gsa') {
                    window.open('https://www.gsasport.com/gr/', '_blank')
                } else if (social === 'google_play') {
                    window.open('https://play.google.com/store/apps/details?id=com.vue.big.app', '_blank')
                } else if (social === 'app_store') {
                    window.open('https://apps.apple.com/us/app/b-i-g/id6748522198', '_blank')
                }
            }
        }
    }
</script>

<style scoped>
.custom-header {
    font-weight: 600;
    font-size: 23px;
    background-color: #232323;
    color: teal;
    height: 90px;
}

.custom-divider {
    border-color: teal;
    border-width: 1px;
    height: 20px;
    margin: 0 10px 0 10px;
}
</style>
